import React from 'react';
import Tag from 'components/DesignSystem/Tag';

export default function Indicator({ active, suffix = 'a' }: { active: boolean, suffix?: string }) {
  if (active) {
    return (
      <Tag type="completed">
        Ativ
        {suffix}
      </Tag>
    );
  }
  return (
    <Tag type="cancelled">
      Inativ
      {suffix}
    </Tag>
  );
}
